export default import.meta.ROLLDOWN_FILE_URL_oa0bBZo047rF7AQKkCO8pQ